// Copyright (c) 2016 Deere & Company

import {
    isNotEmpty,
    isNotNull,
    isNumberInputValid,
    isRepairDateAfterFailureDate,
    validateClaimUseAmountUnits,
    validateClaimUseAmounts,
    validateUseAmountsIfPinExists
} from '../../shared/services/claim-shared-helper';
import TrackClaim from '@deere/cps-it.warranty-model-factory/lib/claim-track';
import {removeEmptyRows} from '../../shared/services/empty-claim-rows';

const hasAtLeastOneClaimItem = claim =>
    claim.parts.length || claim.labor.length || claim.otherCredits.length;

const isNotRequiredForReplacement = (claim, value) =>
    claim.installedBy.key === 'R' || isNotEmpty(value);

const hasComplaintCauseCorrection = complaintCauseCorrection => [
    isNotEmpty(complaintCauseCorrection.causeOfComplaining),
    isNotEmpty(complaintCauseCorrection.howWasComplaintCorrected),
    isNotEmpty(complaintCauseCorrection.operatorsComplaint)
].every(rule => rule);

const isComplaintCauseCorrectionValid = (installedBy, complaintCauseCorrection) =>
    installedBy === 'R' ?
        isNotEmpty(complaintCauseCorrection.causeOfComplaining) :
        hasComplaintCauseCorrection(complaintCauseCorrection);

export const canShowAllSections = (claimNumber, isValidClaim) =>
    isValidClaim || isNotEmpty(claimNumber);

export const isReplacement = (installedBy, claim) =>
    installedBy === 'R' ?
        isNotEmpty(claim.previousInvoiceNumber) && isNumberInputValid(claim.retailInstallDate) :
        true;

export const isValidClaim = (claim, allowedUnitsLength) => [
    isNotEmpty(claim.failureInfo.failurePartNumber),
    isNotEmpty(claim.pin) || isNotEmpty(claim.model) && isNotEmpty(claim.serialNumber),
    validateUseAmountsIfPinExists(claim, allowedUnitsLength),
    isNotEmpty(claim.responsibleAccount.account),
    isNotEmpty(claim.installedBy.key),
    isNotEmpty(claim.application.key),
    isNotEmpty(claim.referenceInfo.ownershipStatus.key),
    isNotEmpty(claim.referenceInfo.referenceNumber1),
    isReplacement(claim.installedBy.key, claim),
    isNotNull(claim.failureInfo.failureDate),
    isNotNull(claim.failureInfo.repairDate),
    isRepairDateAfterFailureDate(claim.failureInfo.repairDate, claim.failureInfo.failureDate)
].every(rule => rule);

export const saveValidate = claim => [
    isValidClaim(claim),
    isNotEmpty(claim.additionalFailureInfo.failureMode.key),
    isNotEmpty(claim.additionalFailureInfo.failureArea),
    isNotEmpty(claim.additionalFailureInfo.downtime.key),
    isComplaintCauseCorrectionValid(claim.installedBy.key, claim.complaintCauseCommentsBasis),
    hasAtLeastOneClaimItem(removeEmptyRows(claim, TrackClaim))
].every(rule => rule);

export const mapFormValidation = (property, value, claim) => {

    const boundIsNotRequiredForReplacement = isNotRequiredForReplacement.bind(null, claim);

    const map = {
        application: isNotEmpty,
        averageLugHeight: isNotNull,
        complaintCause: isNotEmpty,
        complaintCorrection: isNotEmpty,
        downtime: isNotEmpty,
        failureArea: isNotEmpty,
        failureDate: isNotNull,
        failureMode: isNotEmpty,
        failurePart: isNotEmpty,
        installedBy: isNotEmpty,
        lugHeightUnit: isNotEmpty,
        model: isNotEmpty,
        operatorsComplaint: isNotEmpty,
        ownershipStatus: isNotEmpty,
        partSerialNumber: isNotEmpty,
        partUseAmount: isNotEmpty,
        partUseAmountUnit: isNotEmpty,
        pin: boundIsNotRequiredForReplacement,
        previousInvoiceNumber: isNotEmpty,
        repairDate: isNotNull,
        responsibleAccount: isNotEmpty,
        retailInstallDate: isNotNull,
        serialNumber: isNotEmpty,
        useAmount: validateClaimUseAmounts,
        useAmountUnit: validateClaimUseAmountUnits,
        workOrderOne: isNotEmpty
    };

    return map[property](value, claim);

};

export const checkClaimValidity = (currentPageValidity, validationFailed, selectedAction) =>
    selectedAction === 'VALIDATE' ?
        !validationFailed && !currentPageValidity :
        false;



// WEBPACK FOOTER //
// ./src/claim/track/services/claim-validation-helper.js